import React from 'react';
import { Instagram } from 'lucide-react';

const TikTokIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.91a8.16 8.16 0 0 0 4.77 1.52V7a4.85 4.85 0 0 1-1.84-.31z" />
  </svg>
);

const SOCIALS = [
  { name: 'Instagram', handle: '@stefens.detailing', url: 'https://www.instagram.com/stefens.detailing/', Icon: Instagram, testId: 'social-instagram-link' },
  { name: 'TikTok', handle: '@stefens_detailing', url: 'https://www.tiktok.com/@stefens_detailing', Icon: TikTokIcon, testId: 'social-tiktok-link' },
];

export const SocialMediaHub = () => {
  return (
    <section id="social" className="py-20 px-6 bg-neutral-50">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-display italic uppercase text-3xl md:text-4xl font-extrabold text-neutral-950 mb-3">Follow Us</h2>
        <p className="text-neutral-600 mb-10">See our latest transformations on social</p>

        <div className="flex items-center justify-center gap-6">
          {SOCIALS.map(({ name, handle, url, Icon, testId }) => (
            <a
              key={name}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={testId}
              aria-label={`${name} — ${handle}`}
              className="group flex flex-col items-center justify-center w-32 h-32 md:w-40 md:h-40 bg-white border border-neutral-200 hover:border-red-600 rounded-sm shadow-sm hover:shadow-xl hover:-translate-y-1"
            >
              <Icon className="w-10 h-10 md:w-12 md:h-12 text-neutral-950 group-hover:text-red-600 transition-colors duration-300" />
              <span className="mt-3 text-sm text-neutral-600 group-hover:text-neutral-950 transition-colors">{handle}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
